import type { ParamsValidator } from 'src/components/RouteParamsValidator';
import type { BroadcastRouteParams } from './types';
import { BroadcastUrlType } from './types';

export const validateBroadcastType: ParamsValidator<BroadcastRouteParams> = ({ broadcastType }) =>
  Object.values(BroadcastUrlType).includes(broadcastType);
